import type { ReactElement } from 'react';
import { Link } from 'react-aria-components';
import type { ApiError } from '../api/errors';
import { Banner } from '../ui/Banner';

/** `REPORTPAD_UPGRADE_URL` tagged for a Stripe payment link: `client_reference_id`
 *  names the workspace for `plan:set`, `prefilled_email` saves retyping. Only
 *  accounts mode's label is an email. */
export function upgradeHref(
  base: string | null,
  who: { workspaceId: string | null; mode: 'accounts' | 'admin'; userLabel: string | null }
): string | null {
  if (!base || !who.workspaceId) return base;
  const url = new URL(base);
  url.searchParams.set('client_reference_id', who.workspaceId);
  if (who.mode === 'accounts' && who.userLabel) url.searchParams.set('prefilled_email', who.userLabel);
  return url.toString();
}

/** The link text per `details.kind`: the row cap names what Pro buys; the abuse caps just offer the upgrade. */
function upgradeLabel(kind: unknown): string {
  return kind === 'published_links' || kind === 'daily_writes' ? 'Upgrade' : 'Upgrade to Pro for 50,000';
}

/** The web form of `PLAN_LIMIT_EXCEEDED`: the server's plan-neutral sentence,
 *  plus an upgrade link when one is configured. */
export function PlanLimitMessage(props: { error: ApiError; upgradeUrl: string | null }): ReactElement {
  return (
    <Banner tone="danger" title={props.error.message}>
      {props.upgradeUrl ? (
        <Link
          href={props.upgradeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="font-ui font-semibold text-ink underline cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink"
        >
          {upgradeLabel(props.error.details.kind)}
        </Link>
      ) : null}
    </Banner>
  );
}
